import { listPrepaidsQuery } from '@shared/services/gql.service';

export enum PrepaidTypeLabel {
  PREPAID_TYPE_AMORTIZE = 'Amortize',
  PREPAID_TYPE_INCREASE = 'Increase',
  PREPAID_TYPE_RECLASS = 'Reclass',
}

export type AdjustmentsToPrepaidErrorRow = {
  adjustment: AdjustmentsToPrepaidRow;
  causes: (
    | 'accrual_period_closed_month'
    | 'amortize_both_blank'
    | 'increase_both_blank'
    | 'increase_no_invoice'
    | 'long_term_amortize'
    | 'long_term_increase'
    | 'payment_date_closed_month'
    | 'pivot_column'
    | 'prepaid_type'
    | 'short_term_amortize'
    | 'short_term_increase'
    | 'total_impact_to_prepaid_amortize'
    | 'total_impact_to_prepaid_increase'
    | 'total_impact_to_prepaid_reclass'
  )[];
};

export interface AdjustmentsToPrepaidRow extends listPrepaidsQuery {
  isNewAdjustment: boolean;
  pivot_column: string[];
  total_impact_to_prepaid: number;
}

export interface AdjustmentsToPrepaidTotals {
  investigator_amount: number;
  invoice_total: number;
  long_term_amount: number;
  passthrough_amount: number;
  services_amount: number;
  short_term_amount: number;
  total_expense_per_invoice: number;
  total_impact_to_prepaid: number;
}
